import { useEffect, useState } from 'react';
import { getInviteFeatures, InviteFeatures } from '../services/invite';

export const useInviteFeatures = () => {
  const [features, setFeatures] = useState<InviteFeatures>({ registrationEnabled: true, purchaseEnabled: false });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    getInviteFeatures()
      .then((value) => { if (active) setFeatures(value); })
      .catch(() => undefined)
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  return { ...features, loading };
};
